import universal from 'react-universal-component';

export default universal(() => import('./LearnMore'));

// export default universal(import('./LearnMore'), {loading: <LoadingComponent />});


// WEBPACK FOOTER //
// ./src/app/views/LearnMore/index.js